/**
 * Logica di filtro pratiche — estratta da DataContext per testabilità.
 * Filtri combinati in AND.
 */

import { getDocumentController } from '@/lib/practicePermissions';
import { ROLES } from '@/lib/roles';

export function filterPractices(practices, filters) {
  return practices.filter((p) => {
    if (filters.search) {
      const q = filters.search.toLowerCase();
      const matchId = String(p.id || '').toLowerCase().includes(q);
      const matchCodice = String(p.codiceSito || '').toLowerCase().includes(q);
      const matchNome = String(p.nomeSito || '').toLowerCase().includes(q);
      if (!matchId && !matchCodice && !matchNome) return false;
    }
    if (filters.studioProgettazione && p.studioProgettazione !== filters.studioProgettazione) return false;
    if (filters.tipologiaLavorazione && p.tipologiaLavorazione !== filters.tipologiaLavorazione) return false;
    if (filters.ditta && p.ditta !== filters.ditta) return false;
    if (filters.workflowStatus && p.workflowStatus !== filters.workflowStatus) return false;
    // Filtro "Categoria Rifiuto": match se l'array categorieRifiuto della pratica
    // contiene la categoria selezionata (pratiche senza rifiuti = escluse).
    if (filters.categoriaRifiuto
      && !(Array.isArray(p.categorieRifiuto) && p.categorieRifiuto.includes(filters.categoriaRifiuto))) return false;
    // Filtro "Errori": soglia sul totale rifiuti della pratica (documenti + preventivo).
    // 'zero' = esattamente nessun errore; '1'..'4' = almeno N errori.
    if (filters.minErrori) {
      const totaleErrori = (p.numeroErroriDocumenti || 0) + (p.numeroErroriPreventivo || 0);
      if (filters.minErrori === 'zero') {
        if (totaleErrori !== 0) return false;
      } else if (totaleErrori < Number(filters.minErrori)) {
        return false;
      }
    }
    // Filtro "Controllore documenti": usa il controllore REALE (getDocumentController),
    // che considera sia fornitoreIsInternalHq sia inCaricoFastweb (presa in carico Fastweb).
    if (filters.fornitoreIsInternalHq === 'yes' && getDocumentController(p) !== ROLES.FASTWEB) return false;
    if (filters.fornitoreIsInternalHq === 'no' && getDocumentController(p) !== ROLES.HQ) return false;
    if (filters.periodoDa || filters.periodoA) {
      const ts = p.dataInizio?.toDate ? p.dataInizio.toDate() : p.dataInizio ? new Date(p.dataInizio) : null;
      if (!ts) return false;
      if (filters.periodoDa && ts < new Date(filters.periodoDa)) return false;
      if (filters.periodoA) {
        const endOfDay = new Date(filters.periodoA);
        endOfDay.setHours(23, 59, 59, 999);
        if (ts > endOfDay) return false;
      }
    }
    return true;
  });
}
